"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const three_1 = require("three");
const types_1 = require("~/store/types");
const utils_3d_1 = require("../../utils/utils.3d");
const Viewer_1 = __importDefault(require("../../Viewer"));
const commands_1 = require("../../commands");
function getConnectionObjectsBetweenPanelsAndExtrusionsPerContourToBeUpdated(connectionObjects) {
    const connectionObjectsPerContour = new Map();
    const collectConnectionObjects = (extrusion) => {
        extrusion.connectedItems.forEach((connectedItem) => {
            if (connectedItem.itemType !== types_1.ITEM_TYPE.PANEL) {
                return;
            }
            const connectionObject = Viewer_1.default.instance
                .getDesignProMain()
                .connectionManager.getConnectionObject(connectedItem.uuid, extrusion.uuid);
            if (!connectionObject) {
                return;
            }
            const panel = Viewer_1.default.instance.getObjectById(connectedItem.uuid);
            if (!panel) {
                return;
            }
            connectionObjectsPerContour.set(panel, connectionObject);
        });
    };
    connectionObjects.forEach((connectionObject) => {
        const mainObject = connectionObject.getMainObject();
        const connectedObject = connectionObject.getConnectedObject();
        if (!(0, utils_3d_1.isExtrusion)(mainObject) || !(0, utils_3d_1.isExtrusion)(connectedObject)) {
            return;
        }
        // Currently PanelInSlotHelper doesn't support inserting panel on angled extrusion hover.
        if (!(0, utils_3d_1.isAngledExtrusion)(mainObject)) {
            collectConnectionObjects(mainObject);
        }
        if (!(0, utils_3d_1.isAngledExtrusion)(connectedObject)) {
            collectConnectionObjects(connectedObject);
        }
    });
    return Array.from(connectionObjectsPerContour.values());
}
class PanelInSlotUpdateHelper {
    onFastenersUpdated(connectionObjects) {
        const connectionObjectsPerContour = getConnectionObjectsBetweenPanelsAndExtrusionsPerContourToBeUpdated(connectionObjects);
        connectionObjectsPerContour.forEach((connectionObject) => {
            var _a;
            const { mainItem: panelItem, connectedItem: extrusionItem } = connectionObject.getConnectionItems();
            if (!panelItem || !extrusionItem) {
                return;
            }
            const panel = connectionObject.getMainObject();
            const extrusion = connectionObject.getConnectedObject();
            const extrusionSlots = extrusion.getSlots();
            const [connectedSlotNumber] = (_a = extrusionItem.slotNumbers) !== null && _a !== void 0 ? _a : [];
            if (!extrusionSlots || !connectedSlotNumber) {
                return;
            }
            const connectedSlot = extrusionSlots.find((slot) => slot.slotNumber === connectedSlotNumber);
            if (!connectedSlot) {
                return;
            }
            panel.updateMatrixWorld(true);
            const panelBoundingBox = panel.mesh.geometry.boundingBox;
            const panelCenter = panelBoundingBox
                ? panelBoundingBox.getCenter(new three_1.Vector3()).applyMatrix4(panel.mesh.matrixWorld)
                : panel.position.clone();
            const { panelInsertHelper } = Viewer_1.default.instance.getDesignProMain();
            const panelWasRebuilt = panelInsertHelper.insert(panelCenter, panel, extrusion, connectedSlot);
            if (panelWasRebuilt) {
                this.pendingPanel = panel;
            }
        });
    }
    syncUpdate() {
        if (this.pendingPanel) {
            const viewer = Viewer_1.default.instance;
            const history = viewer.getDesignProMain().historyService;
            new commands_1.RemoveObjectCommand([this.pendingPanel], viewer, history).execute(false);
            new commands_1.AddObjectCommand([this.pendingPanel], viewer, history).execute(false);
            this.pendingPanel = null;
        }
    }
}
exports.default = new PanelInSlotUpdateHelper();
